import React, { useEffect, useState } from 'react';
import { i18n } from '../i18n/i18n';
import { isNewerVersion, liveBundleName, runningBundleName } from '../utils/appVersion';

const CHECK_EVERY_MS = 10 * 60 * 1000;

/**
 * "A new version is ready — Update" (2026-10-13). Checks when the app comes back to the screen
 * and every 10 minutes; never in development. Reloading is the user's choice, so nobody loses
 * what they were typing.
 */
const UpdateBanner: React.FC = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    const running = runningBundleName();
    if (!running) return;
    let stopped = false;
    const check = async () => {
      if (stopped || document.visibilityState !== 'visible') return;
      if (isNewerVersion(running, await liveBundleName())) setReady(true);
    };
    const onVisible = () => { if (document.visibilityState === 'visible') void check(); };
    document.addEventListener('visibilitychange', onVisible);
    const timer = window.setInterval(check, CHECK_EVERY_MS);
    return () => {
      stopped = true;
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(timer);
    };
  }, []);

  if (!ready) return null;
  return (
    <div role="status" className="fixed left-1/2 -translate-x-1/2 bottom-[calc(6rem+env(safe-area-inset-bottom,0px))] z-[10070] w-[min(92vw,30rem)] flex items-center gap-3 rounded-kid-card border-2 border-kid-green bg-kid-card dark:bg-kid-card-dark text-kid-text dark:text-kid-text-dark shadow-xl px-4 py-3">
      <span className="flex-1 font-bold">{i18n.t('common.update_ready')}</span>
      <button type="button" onClick={() => window.location.reload()} className="min-h-[44px] px-5 rounded-full bg-kid-green text-white font-bold">
        {i18n.t('common.update_now')}
      </button>
    </div>
  );
};

export default UpdateBanner;
